import React from "react";
import { Link } from "react-router-dom";
import { MapPin, GraduationCap, Briefcase, SealCheck, Sparkle } from "@phosphor-icons/react";
import { ProfilePhoto } from "@/components/AuthImage";
import { VerifiedBadge } from "@/components/VerifiedBadge";

export default function ProfileCard({ profile, actions }) {
  if (!profile) return null;
  return (
    <div className="group bg-white border border-brand-line hover:-translate-y-1 hover:shadow-ambient transition-all duration-300" data-testid={`profile-card-${profile.id}`}>
      <Link to={`/profile/${profile.id}`} className="block">
        <div className="p-6 border-b border-brand-line flex items-start gap-4">
          <ProfilePhoto profile={profile} className="w-16 h-16 flex-shrink-0 rounded-full" size="text-2xl" />
          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-2">
              <div className="font-serif text-xl text-brand-ink leading-tight truncate">
                {profile.name}{profile.age ? `, ${profile.age}` : ""}
              </div>
              {profile.verified && <SealCheck size={16} weight="fill" className="text-brand-terracotta flex-shrink-0" />}
              <VerifiedBadge verifications={profile.verifications} size="sm" />
              {profile.ai_verification?.verdict === "verified" && (
                <span
                  className="inline-flex items-center gap-1 text-[9px] uppercase tracking-widest bg-brand-ink text-brand-gold px-2 py-0.5 rounded-full flex-shrink-0"
                  title={`AI-Verified · ${profile.ai_verification.overall_score}/100`}
                  data-testid={`ai-verified-badge-${profile.id}`}
                >
                  <Sparkle size={9} weight="fill" /> AI
                </span>
              )}
            </div>
            <div className="mt-1 text-xs text-brand-muted flex items-center gap-1">
              <MapPin size={12} /> {[profile.city, profile.country].filter(Boolean).join(", ") || "Location undisclosed"}
            </div>
          </div>
        </div>
        <div className="p-6 space-y-2 text-sm">
          {profile.profession ? (
            <div className="flex items-center gap-2 text-brand-ink">
              <Briefcase size={14} className="text-brand-terracotta" /> {profile.profession}
            </div>
          ) : <div className="text-brand-muted text-xs italic">Profession — not shared</div>}
          {profile.education && (
            <div className="flex items-center gap-2 text-brand-muted"><GraduationCap size={14} /> {profile.education}</div>
          )}
          <div className="pt-2 text-xs text-brand-muted uppercase tracking-widest divider-serif">
            <span>{profile.community || "Muslim"}</span>
            {profile.mother_tongue && <span>{profile.mother_tongue}</span>}
          </div>
        </div>
      </Link>
      {actions && <div className="px-6 pb-6">{actions}</div>}
    </div>
  );
}
